import { CoinAmount } from './index'

export enum ProposalStatus {
  Unspecified = 'PROPOSAL_STATUS_UNSPECIFIED',
  DepositPeriod = 'PROPOSAL_STATUS_DEPOSIT_PERIOD',
  VotingPeriod = 'PROPOSAL_STATUS_VOTING_PERIOD',
  Passed = 'PROPOSAL_STATUS_PASSED',
  Rejected = 'PROPOSAL_STATUS_REJECTED',
  Failed = 'PROPOSAL_STATUS_FAILED',
  Canceled = 'PROPOSAL_STATUS_CANCELED',
}

export enum VoteOption {
  Unspecified = 'VOTE_OPTION_UNSPECIFIED',
  Yes = 'VOTE_OPTION_YES',
  Abstain = 'VOTE_OPTION_ABSTAIN',
  No = 'VOTE_OPTION_NO',
  NoWithVeto = 'VOTE_OPTION_NO_WITH_VETO',
}

export interface ProposalMessage {
  '@type': string
  [key: string]: unknown
}

export interface TallyResult {
  yes_count: string
  abstain_count: string
  no_count: string
  no_with_veto_count: string
}

export interface Proposal {
  id: string
  messages: ProposalMessage[]
  status: ProposalStatus
  final_tally_result?: TallyResult
  submit_time: string
  deposit_end_time: string
  voting_start_time: string
  voting_end_time: string
  total_deposit: CoinAmount[]
  metadata: string
}

export interface WeightedVoteOption {
  option: VoteOption
  weight: string
}

export interface Vote {
  proposal_id: string
  voter: string
  options: WeightedVoteOption[]
  metadata: string
}
